module.exports = __webpack_public_path__ + "img/3600.46f1e346.jpg";